import { render, staticRenderFns } from "./trendSetter.vue?vue&type=template&id=71c9424f&scoped=true"
import script from "./trendSetter.vue?vue&type=script&lang=js"
export * from "./trendSetter.vue?vue&type=script&lang=js"
import style0 from "./trendSetter.vue?vue&type=style&index=0&id=71c9424f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c9424f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71c9424f')) {
      api.createRecord('71c9424f', component.options)
    } else {
      api.reload('71c9424f', component.options)
    }
    module.hot.accept("./trendSetter.vue?vue&type=template&id=71c9424f&scoped=true", function () {
      api.rerender('71c9424f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/redBook/component/trendSetter.vue"
export default component.exports